export const APP_STATUS_CODE_APPROVED = '7';

export const APP_STATUS_CODE_DECLINED = '8';

export const APP_STATUS_CODE_PENDING = '1';

export const APP_STATUS_CODE_PROCESSING = '0';
